import {_, o, Values, x, Game} from "../models/Game.model";

const n = 3;

export class GameEngine {
    initial(id: number, player: string): Game {
        return {
            id,

            player,
            last: _,
            next: x,
            values: Array.from({length: n * n}, () => _),

            waiting: false,
            finished: false,
            stale: false,
            won: false,
            winner: _,
            loser: _,
            cross: -1,
            horizontal: -1,
            vertical: -1
        };
    }

    canPlay = (game: Game): boolean => {
        return game.player === _ || game.player === game.next;
    }

    hasHorizontalMatch(values: Values): [string, number] {
        for (let row = 0; row < n; row++) {
            let first = values[row * n];
            if (first === _) {
                continue;
            }
            let all = true;
            for(let col = 0; col < n; col++) {
                if(values[row * n + col] !== first) {
                    all = false;
                    break;
                }
            }
            if (all) {
                return [first, row];
            }
        }
        return [_, -1];
    }

    hasVerticalMatch(values: Values): [string, number] {
        for (let col = 0; col < n; col++) {
            let first = values[col];
            if (first === _) {
                continue;
            }
            let all = true;
            for (let row = 0; row < n; row++) {
                if (values[row * n + col] !== first) {
                    all = false;
                    break;
                }
            }
            if (all) {
                return [first, col];
            }
        }
        return [_, -1];
    }

    hasCrossMatch(values: Values): [string, number] {
        const first = values[0];
        if (first !== _) {
            let all = true;
            for (let i = 0; i < n; i++) {
                const index = i * n + i;
                if (values[index] !== first) {
                    all = false;
                    break;
                }
            }
            if (all) {
                return [first, 0];
            }
        }

        const last = values[n - 1];
        if (last !== _) {
            let all = true;
            for (let i = 0; i < n; i++) {
                const index = (n - 1) * (i + 1);
                if (values[index] !== last) {
                    all = false;
                    break;
                }
            }
            if (all) {
                return [last, 1];
            }
        }

        return [_, -1];
    }
    
    update(game: Game, row: number, col: number): Game {
        if (game.finished || game.values[row * n + col] !== _) {
            return game;
        }

        const last = game.next;
        const next = game.next === o ? x : o;

        const values = [...game.values];
        values[row * n + col] = last;

        let winner: string, horizontal: number
            , vertical = -1, cross = -1;
        [winner, horizontal] = this.hasHorizontalMatch(values);
        if (winner === _) {
            [winner, vertical] = this.hasVerticalMatch(values);
        }
        if (winner === _) {
            [winner, cross] = this.hasCrossMatch(values);
        }

        if (winner !== _) {
            const finished = true;
            const won = true;
            const loser = winner === x ? o : x
            return {...game, last, next, values, finished, won, winner, loser, horizontal, vertical, cross};
        }

        const finished = game.values.every(v => v !== _);
        if (finished) {
            const stale = true;
            return {...game, last, next, values, finished, stale};
        }

        return {...game, last, next, values};
    }
}